module.exports = __webpack_public_path__ + "img/1590115609.2e157cb7.jpg";